import {IonicModule} from '@ionic/angular';
import {RouterModule} from '@angular/router';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TeamPage} from './team.page';

import {TeamPageRoutingModule} from './team-routing.module';
import {HeaderModule} from '../../components/header/header.module';
import {TranslateDirective, TranslatePipe} from '@ngx-translate/core';
import {SwiperModule} from 'swiper/angular';
import {TeamListModule} from 'src/app/components/team-list/team-list.module';
import {RequestListModule} from 'src/app/components/request-list/request-list.module';
import {TeamInvitationModule} from 'src/app/components/team-invitation/team-invitation.module';
import {CompaniesListModule} from 'src/app/components/companies-list/companies-list.module';
import {PanelHeaderComponent} from "../../components/panel-header/panel-header.component";

@NgModule({
    imports: [
        IonicModule,
        CommonModule,
        FormsModule,
        RouterModule.forChild([{path: '', component: TeamPage}]),
        TeamPageRoutingModule,
        HeaderModule,
        TranslatePipe,
        TranslateDirective,
        SwiperModule,
        TeamInvitationModule,
        TeamListModule,
        RequestListModule,
        CompaniesListModule,
        ReactiveFormsModule,
        PanelHeaderComponent,

    ],
    exports: [
        TeamPage
    ],
    declarations: [
        TeamPage,
    ]
})
export class TeamPageModule {
}
